import { render, staticRenderFns } from "./DayRateForm.vue?vue&type=template&id=afe68744&"
import script from "./DayRateForm.vue?vue&type=script&lang=js&"
export * from "./DayRateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports